import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the table view for partner products.
 * @extends JetView
 */
export default class tablePartnersProductsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters

        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            id: 'datatable', // ID for the DataTable
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'rating', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    template: function (obj) {
                                        // Template function for rendering
                                        if (devConfig.getPermAction('partnersProvidersEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Edit icon if permission granted
                                        } else {
                                            return ''; // No icon if permission denied
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: 'Id', // Column header
                                    width: 50, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Provider', // Column ID
                                    header: _('Proveedor'), // Localized column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Partner', // Column ID
                                    header: _('Partner'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'IsActivate', // Column ID
                                    header: _('Estado'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'IsVerified', // Column ID
                                    header: _('Verificado'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 90, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'FilterCountry', // Column ID
                                    header: _('Filtro País'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Maximum', // Column ID
                                    header: _('Máximo'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Minimum', // Column ID
                                    header: _('Mínimo'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Detail', // Column ID
                                    header: _('Detalle'), // Localized column header
                                    width: 180, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handler for click events
                                edit: function (euv, id) {
                                    $$('editwinPartnerProducts').show(); // Show edit window on click
                                },
                            },
                            math: true, // Enable mathematical operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                            // Data source URL for the DataTable
                            url:
                                devConfig.geturlApi() +
                                'PartnersProviders/GetPartnersProviders?Partner=' +
                                id_partner +
                                '&',
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The DataTable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the DataTable
        var url = grid.data.url; // Data source URL
        var cthis = this; // Reference to the current context
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        var providers = []; // Array to hold provider data
        var popup = webix.ui({
            // Configuration for the edit window
            view: 'window',
            id: 'editwinPartnerProducts', // ID for the edit window
            width: screen.width < 500 ? 350 : 450, // Width based on screen size
            height: screen.width < 500 ? 680 : 580, // Height based on screen size
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Editar Partner') }, // Label for the window
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide the window on click
                        },
                    },
                ],
            },
            position: 'center', // Center position for the window
            modal: false, // Non-modal window
            body: {
                view: 'scrollview', // Scrollable view
                scroll: 'y', // Vertical scrolling
                body: {
                    view: 'form', // Form for editing partner products
                    id: 'editform', // ID for the form
                    width: screen.width < 500 ? 350 : 450, // Width based on screen size
                    height: screen.width < 500 ? 680 : 530, // Height based on screen size
                    elements: [
                        // Form elements
                        {
                            view: 'text', // Text input for ID
                            label: 'Id',
                            name: 'Id',
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'text', // Text input for Provider
                            label: _('Proveedor'),
                            name: 'Provider',
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'combo', // Combo box for IsActivate
                            label: _('Estado'),
                            name: 'IsActivate',
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'combo', // Combo box for IsVerified
                            label: _('Verificado'),
                            name: 'IsVerified',
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'combo', // Combo box for FilterCountry
                            label: _('Filtro País'),
                            name: 'FilterCountry',
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'text', // Text input for Maximum
                            label: _('Máximo'),
                            name: 'Maximum',
                            attributes: { type: 'number' }, // Input type
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'text', // Text input for Minimum
                            label: _('Mínimo'),
                            name: 'Minimum',
                            attributes: { type: 'number' }, // Input type
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'text', // Text input for Detail
                            label: _('Detalle'),
                            name: 'Detail',
                            labelWidth: 160, // Label width
                            readonly: false, // Editable field
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            margin: 10, // Margin for the next element
                            cols: [
                                {
                                    view: 'text', // Text input for Note
                                    labelPosition: 'top', // Label position
                                    label: _('Explicación'),
                                    name: 'Note',
                                    labelWidth: 160, // Label width
                                    attributes: { type: 'text' }, // Input type
                                },
                            ],
                        },
                        {
                            cols: [
                                // Buttons for Cancel and Save
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'),
                                    click: function () {
                                        this.getTopParentView().hide(); // Hide the window on click
                                    },
                                },
                                {
                                    view: 'button', // Save button
                                    type: 'form',
                                    value: _('Guardar'),
                                    click: function ($e) {
                                        var values = $$('editform').getValues(); // Get form values
                                        var c2this = this; // Reference to the current context
                                        values.Partner = id_partner; // Add partner ID to values
                                        webix
                                            .ajax() // AJAX request to save data
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'PartnerProvider/UpdatePartnerProvider',
                                                values, // Data to send
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message on failure
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        text = JSON.parse(text); // Parse response
                                                        if (text.HasError) {
                                                            webix.message(
                                                                'Error: ' + text.AlertMessage, // Show error message if any
                                                            );
                                                        } else {
                                                            $$('editform').clear(); // Clear the form
                                                            c2this.getTopParentView().hide(); // Hide the window
                                                            webix.message(
                                                                'Proveedor Partner Editado', // Success message
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        var popupAdd = webix.ui({
            // Configuration for the add window
            view: 'window',
            id: 'AddPartnerProducts', // ID for the add window
            width: screen.width < 500 ? 350 : 450, // Width based on screen size
            height: screen.width < 500 ? 450 : 450, // Height based on screen size
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Añadir Proveedor Partner') }, // Label for the window
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide the window on click
                        },
                    },
                ],
            },
            position: 'center', // Center position for the window
            modal: true, // Modal window
            body: {
                view: 'scrollview', // Scrollable view
                scroll: 'y', // Vertical scrolling
                body: {
                    view: 'form', // Form for adding partner products
                    id: 'addform', // ID for the form
                    width: screen.width < 500 ? 350 : 450, // Width based on screen size
                    height: screen.width < 500 ? 450 : 400, // Height based on screen size
                    elements: [
                        // Form elements
                        {
                            view: 'combo', // Combo box for Provider
                            label: _('Proveedores'),
                            name: 'Provider',
                            id: 'AddProvider', // ID for the combo box
                            options: providers, // Options for the combo box
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'combo', // Combo box for IsActivate
                            label: _('Estado'),
                            name: 'IsActivate',
                            value: 'A', // Default value
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'combo', // Combo box for IsVerified
                            label: _('Verificado'),
                            name: 'IsVerified',
                            value: 'I', // Default value
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'combo', // Combo box for FilterCountry
                            label: _('Filtro País'),
                            name: 'FilterCountry',
                            value: 'I', // Default value
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'text', // Text input for Maximum
                            label: _('Máximo'),
                            name: 'Maximum',
                            value: 0, // Default value
                            attributes: { type: 'number' }, // Input type
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'text', // Text input for Minimum
                            label: _('Mínimo'),
                            name: 'Minimum',
                            value: 0, // Default value
                            attributes: { type: 'number' }, // Input type
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'text', // Text input for Detail
                            label: _('Detalles'),
                            name: 'Detail',
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            cols: [
                                // Buttons for Cancel and Save
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'),
                                    click: function () {
                                        this.getTopParentView().hide(); // Hide the window on click
                                        $$('addform').clear(); // Clear the form
                                    },
                                },
                                {
                                    view: 'button', // Save button
                                    type: 'form',
                                    value: _('Guardar'),
                                    click: function ($e) {
                                        var values = $$('addform').getValues(); // Get form values
                                        values.Partner = id_partner; // Add partner ID to values
                                        var c2this = this; // Reference to the current context
                                        webix
                                            .ajax() // AJAX request to save data
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'PartnerProvider/CreatePartnerProvider',
                                                values, // Data to send
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message on failure
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        text = JSON.parse(text); // Parse response
                                                        if (text.HasError) {
                                                            webix.message(
                                                                'Error: ' + text.AlertMessage, // Show error message if any
                                                            );
                                                        } else {
                                                            $$('addform').clear(); // Clear the form
                                                            c2this.getTopParentView().hide(); // Hide the window
                                                            webix.message(
                                                                'Proveedor Partner Agregado', // Success message
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        this.on(this.app, 'addProviderPartner:button', (filter) => {
            popupAdd.show(); // Show add window on event
            var optionsCountries = $$('AddProvider').getList(); // Get provider list
            optionsCountries.clearAll(); // Clear existing options
            optionsCountries.parse(providers); // Parse new options
        });
        var filter = ''; // Initialize filter variable
        this.on(this.app, 'partnerProvider:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object for end
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Partner=' + id_partner; // Add partner ID to query
            grid.clearAll(); // Clear the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter variable
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data based on selected player
            );
        });
        grid.attachEvent('onItemDblClick', function (id, e, node) {
            var item = this.getItem(id); // Get double-clicked item
            popup.show(); // Show edit window
        });
        $$('editform').bind($$('datatable')); // Bind edit form to DataTable
        webix
            .ajax() // AJAX request to fetch providers
            .headers({
                'Content-type': 'application/json', // Set content type
            })
            .post(devConfig.geturlApi() + 'Providers/GetProductProviders', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message on failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(
                        text
                            .replace(/"Id"/g, '"id"') // Normalize response keys
                            .replace(/"Name"/g, '"value"'),
                    );
                    console.log(data); // Log the fetched data
                    providers = data.Data; // Store provider data
                },
            });
    }
}

// FILE DOCUMENTED
